//Contains custom data for our series voltage references.  Because the references are modeled with an internal amplifier that require additional curve-fitting by the modelers, this file is 
// used to store and edit the data without fear of it being overwritten by the python automation script which overwrites the reference-tpc-database.js file.  The data in 
// this file should be elements that are not readily discerned from the datasheet (i.e. table data or plots should be in the pdb-database & tpc-database files, respectively)
export let data = {
    "map": {
        "LT6657AHMS8-1.25": "LT6657-1.25",
        "LT6657AHMS8-2.5": "LT6657-2.5",
        "LT6657AHMS8-3": "LT6657-3",
        "LT6657AHMS8-4.096": "LT6657-4.096",
        "LT6657AHMS8-5": "LT6657-5",
        "LT6657BHMS8-1.25": "LT6657-1.25",
        "LT6657BHMS8-2.5": "LT6657-2.5",
        "LT6657BHMS8-3": "LT6657-3",
        "LT6657BHMS8-4.096": "LT6657-4.096",
        "LT6657BHMS8-5": "LT6657-5",

        "LTC6655B-1.25": "LTC6655-1.25",
        "LTC6655B-2.048": "LTC6655-2.048",
        "LTC6655B-2.5": "LTC6655-2.5",
        "LTC6655B-3": "LTC6655-3",
        "LTC6655B-3.3": "LTC6655-3.3",
        "LTC6655B-4.096": "LTC6655-4.096",
        "LTC6655B-5": "LTC6655-5",
        "LTC6655C-1.25": "LTC6655-1.25",
        "LTC6655C-2.048": "LTC6655-2.048",
        "LTC6655C-2.5": "LTC6655-2.5",
        "LTC6655C-3": "LTC6655-3",
        "LTC6655C-3.3": "LTC6655-3.3",
        "LTC6655C-4.096": "LTC6655-4.096",
        "LTC6655C-5": "LTC6655-5",

        "LTC6655LNB-2.5": "LTC6655LN-2.5",
        "LTC6655LNB-4.096": "LTC6655LN-4.096",
        "LTC6655LNB-5": "LTC6655LN-5",
        "LTC6655LNC-2.5": "LTC6655LN-2.5",
        "LTC6655LNC-4.096": "LTC6655LN-4.096",
        "LTC6655LNC-5": "LTC6655LN-5",

        "ADR3412" : "ADR3412",
        "ADR3420" : "ADR3420",
        "ADR3425" : "ADR3425",
        "ADR3430" : "ADR3430",
        "ADR3433" : "ADR3433",
        "ADR3440" : "ADR3440",
        "ADR3450" : "ADR3450",

        "ADR3610" : "ADR3610",
        "ADR3612" : "ADR3612",
        "ADR3618" : "ADR3618",
        "ADR3620" : "ADR3620",
        "ADR3625" : "ADR3625",
        "ADR3630" : "ADR3630",
        "ADR3633" : "ADR3633",
        "ADR3640" : "ADR3640",
        "ADR3650" : "ADR3650",

        "ADR4520A" : "ADR4520",
        "ADR4520B" : "ADR4520",
        "ADR4525A" : "ADR4525",
        "ADR4525B" : "ADR4525",
        "ADR4525C" : "ADR4525",
        "ADR4525D" : "ADR4525",
        "ADR4530A" : "ADR4530",
        "ADR4530B" : "ADR4530",
        "ADR4533A" : "ADR4533",
        "ADR4533B" : "ADR4533",
        "ADR4540A" : "ADR4540",
        "ADR4540B" : "ADR4540",
        "ADR4540C" : "ADR4540",
        "ADR4540D" : "ADR4540",
        "ADR4550A" : "ADR4550",
        "ADR4550B" : "ADR4550",
        "ADR4550C" : "ADR4550",
        "ADR4550D" : "ADR4550",
        
        // "LTZ1000ACH" : "LTZ1000",
        // "LTZ1000CH" : "LTZ1000",

        "ADAQ2387X_INT_REF" : "ADAQ2387X_INT_REF",
    },
    "partData": {

        "LT6657-1.25":{
            "cmin" : 2.7e-6,
            "rf" : 125,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 1.03, //2.56
            "alpha" : 0.758, //1
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 23.9e-9,
                "rOut" : 30.229,//1.3, //1.5
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat" : "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain": 147.55, //98.75, //100
                        "poles" : [
                            3.835,//1.07, //0.42,
                            580.2,
                        ],
                        "zeros" : [
                            3.977e4
                        ]
                    },
                    // "outputImpedanceOpenLoop": {
                    //     "dataFormat": "pole zero",
                    //     "xUnits": "Hz",
                    //     "yUnits": "Ohms, Degrees",
                    //     "dcResistance": 0.25, 
                    //     "poles": [
                    //         343.2e3,
                    //     ],
                    //     "zeros": [
                    //         65e3,
                    //     ]
                    // },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LT6657-2.5":{
            "cmin": 1e-6,
            "rf": 750,
            "rg": 500,
            "rs": 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 0.659, //2.56
            "alpha" : 0.737, //1
            "bandgapOutputNoise": 1e-9,
            "opAmp": {
                "iNoise" : 0,
                "vNoise": 25.4e-9,
                "rOut" : 3.834, //2.37, //2.5
                "tpcData": {
                    "openLoopGain" : {
                        "dataFormat" : "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain": 117.02, //99.552, //100
                        "poles" : [
                            0.0543, //0.0766, //1.87, //0.995
                            7.517e3
                        ],
                        "zeros" : [
                            1.7e3,
                        ]
                    },
                    // "outputImpedanceOpenLoop": {
                    //     "dataFormat": "pole zero",
                    //     "xUnits": "Hz",
                    //     "yUnits": "Ohms, Degrees",
                    //     "dcResistance": 0.588, 
                    //     "poles": [
                    //         20e3*5.28,
                    //     ],
                    //     "zeros": [
                    //         20e3,
                    //     ]
                    // },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LT6657-3":{
            "cmin": 1e-6,
            "rf": 1000,
            "rg": 500,
            "rs": 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 0.659, //2.56
            "alpha" : 0.737, //1
            "bandgapOutputNoise": 1e-9,
            "opAmp": {
                "iNoise" : 0,
                "vNoise": 25.4e-9,
                "rOut" : 2.37, //2.5
                "tpcData": {
                    "openLoopGain" : {
                        "dataFormat" : "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain": 99.552, //100
                        "poles" : [
                            1.87, //0.995
                        ],
                        "zeros" : [
                        ]
                    },
                    // "outputImpedanceOpenLoop": {
                    //     "dataFormat": "pole zero",
                    //     "xUnits": "Hz",
                    //     "yUnits": "Ohms, Degrees",
                    //     "dcResistance": 0.588, 
                    //     "poles": [
                    //         20e3*5.28,
                    //     ],
                    //     "zeros": [
                    //         20e3,
                    //     ]
                    // },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LT6657-4.096":{
            "cmin": 1e-6,
            "rf": 1548,
            "rg": 500,
            "rs": 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2.56,
            "alpha" : 1,
            "bandgapOutputNoise": 1e-9,
            "opAmp": {
                "iNoise" : 0,
                "vNoise": 25.6e-9,
                "rOut" : 5.16, //5
                "tpcData": {
                    "openLoopGain" : {
                        "dataFormat" : "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain": 101.15, //100
                        "poles" : [
                            2.07, //1.99
                        ],
                        "zeros" : [
                        ]
                    },
                    // "outputImpedanceOpenLoop": {
                    //     "dataFormat": "pole zero",
                    //     "xUnits": "Hz",
                    //     "yUnits": "Ohms, Degrees",
                    //     "dcResistance": 0.25, 
                    //     "poles": [
                    //         20e3*5.28,
                    //     ],
                    //     "zeros": [
                    //         20e3,
                    //     ]
                    // },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LT6657-5":{
            "cmin" : 1e-6,
            "rf" : 2e3,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3.09,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise": 25.6e-9,
                "rOut" : 6.902, //5, //1.39, //5
                "tpcData": {
                    "openLoopGain" : {
                        "dataFormat" : "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain": 118.34, //101.15, //76.84, //101.15, //100
                        "poles" : [
                            0.125,//2.08, //6.92, //2.08, //1.99
                            4.082e3,// 15e3,// 5.12e4,
                            // 35.2e3,
                        ],
                        "zeros" : [
                            1.528e3
                            // 10e3,// 2.69e4
                            // 10e3,
                        ]
                    },
                    // "outputImpedanceOpenLoop": {
                    //     "dataFormat": "pole zero",
                    //     "xUnits": "Hz",
                    //     "yUnits": "Ohms, Degrees",
                    //     "dcResistance": 6.902,//5, //1.39, //1.39
                    //     "poles": [
                    //         // 35.2e3,
                    //     ],
                    //     "zeros": [
                    //         // 10e3,
                    //     ]
                    // },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },

        "LTC6655-1.25":{
            "cmin" : 1e-6,
            "rf" : 125,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655-2.048":{
            "rf" : 524,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655-2.5":{
            "rf" : 750,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655-3":{
            "rf" : 1e3,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655-3.3":{
            "rf" : 1.15e3,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655-4.096":{
            "rf" : 1548,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655-5":{
            "rf" : 2e3,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655LN-2.5":{
            "rf" : 750,
            "rg" : 500,
            "rs" : 300,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655LN-4.096":{
            "rf" : 1548,
            "rg" : 500,
            "rs" : 378,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },
        "LTC6655LN-5":{
            "rf" : 2000,
            "rg" : 500,
            "rs" : 400,
            "cs" : 0,
            "flickerNoiseCorner" : 8,
            "alpha" : 1,
            "bandgapOutputNoise" : 11.9e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 6.64e-9,
                "rOut" : 8000,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 120,
                        "poles" : [
                            0.1,
                            40e3,
                            10e9,
                            10e9,
                            10e9
                        ],
                        "zeros" : [
                            4e3,
                            100e6,
                            100e6,
                            100e6                      
                        ]
                    },
                    "outputImpedanceOpenLoop": {
                        "dataFormat": "pole zero",
                        "xUnits": "Hz",
                        "yUnits": "Ohms, Degrees",
                        "dcResistance": 8000,
                        "poles": [
                            0.1,
                        ],
                        "zeros": [
                            100,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : []
                    }
                }
            }
        },

        "ADR3412":{
            "rf" : 2.12e3, 
            "rg" : 1.06e4, 
            "rs" : 5e5,
            "cs" : 91.4e-12, 
            "flickerNoiseCorner" : 3.742e1, //Larger corner due to contribution only from amp
            "alpha" : 0.9097, 
            "bandgapOutputNoise" : 369.6e-9, 
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 107.4e-9, 
                "rOut" : 2.0925e2,  
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 108.26, //100
                        "poles" : [
                            0.0248, //0.05
                            1.089e4, //7.943e3
                        ],
                        "zeros" : [
                            1.889e3, //1.995e3                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3420":{
            "rf" : 6.4976e3, 
            "rg" : 6.2e3, 
            "rs" : 5e5,
            "cs" : 153e-12, 
            "flickerNoiseCorner" : 7.196e1, 
            "alpha" : 0.9038, 
            "bandgapOutputNoise" : 359.4e-9, 
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 81.33e-9, 
                "rOut" : 1.825e2, 
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 107.86, //100
                        "poles" : [
                            0.03541, //0.0759
                            1.09e4, //7.2e3

                        ],
                        "zeros" : [
                            1.903e3, //1.995e3                    
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3425":{
            "rf" : 7.5e3, 
            "rg" : 5e3, 
            "rs" : 5e5,
            "cs" : 196.5e-12, 
            "flickerNoiseCorner" : 1.386e2, 
            "alpha" : 0.9031, 
            "bandgapOutputNoise" : 363.7e-9, 
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 60.61e-9, 
                "rOut" : 2.152e2, 
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 110.584, //100
                        "poles" : [
                            0.02943, //0.0738
                            1.09e4, //6.7e3
                        ],
                        "zeros" : [
                            1.464e3, //1.595e3                    
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3430":{
            "rf" : 8.4e3, 
            "rg" : 4.2e3, 
            "rs" : 5e5,
            "cs" : 229.2e-12, 
            "flickerNoiseCorner" : 1.899e2, 
            "alpha" : 0.9031, 
            "bandgapOutputNoise" : 364.1e-9, 
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 52.6e-9,  
                "rOut" : 2.124e2, 
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 112.105, //100
                        "poles" : [
                            0.025, //0.0763
                            1.09e4, //8e3
                        ],
                        "zeros" : [
                            1.299e3,  //1.585e3                   
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3433":{
            "rf" : 8.74e3, 
            "rg" : 3.8e3, 
            "rs" : 5e5,
            "cs" : 247.2e-12, 
            "flickerNoiseCorner" : 2.349e2,
            "alpha" : 0.9032, 
            "bandgapOutputNoise" : 364.4e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 47.81e-9,
                "rOut" : 2.144e2,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 109.783, //100
                        "poles" : [
                            0.0339, //0.0775
                            1.09e4, //6.5e3
                        ],
                        "zeros" : [
                            1.231e3, //1.2e3
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3440":{
            "rf" : 9.5976e3, 
            "rg" : 3.1e3, 
            "rs" : 5e5,
            "cs" : 279.8e-12, 
            "flickerNoiseCorner" : 3.584e2, 
            "alpha" : 0.9036, 
            "bandgapOutputNoise" : 358.4e-9, 
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 39.44e-9, 
                "rOut" : 2.077e2, 
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 110.14, //100
                        "poles" : [
                            0.0343, //0.0831
                            1.09e4, //8.3e3
                        ],
                        "zeros" : [
                            1.143e3, //1.4e3
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3450":{
            "rf" : 1e4, 
            "rg" : 2.5e3, 
            "rs" : 5e5,
            "cs" : 308.8e-12, 
            "flickerNoiseCorner" : 6.435e2, 
            "alpha" : 0.9041,  
            "bandgapOutputNoise" : 362.5e-9, 
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 30.2e-9,  
                "rOut" : 2.134e2, 
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 110.15, //100
                        "poles" : [
                            0.03878, //0.0898
                            1.09e4, //8.2e3

                        ],
                        "zeros" : [
                            1.069e3, //1.385                    
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3612":{
            "rf" : 2.4e4,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3,
            "alpha" : 0.899,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 90e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 79.55,
                        "poles" : [
                            0.5,
                            650,
                        ],
                        "zeros" : [
                            250,
                            15849,                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3618":{
            "rf" : 9.6e4,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2.5,
            "alpha" : 0.95,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 93.33e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 79.805,
                        "poles" : [
                            0.5,
                            500,
                        ],
                        "zeros" : [
                            200,
                            1e4,                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3620":{
            "rf" : 1.2576e5,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2.5,
            "alpha" : 0.965,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 93.33e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 79.92,
                        "poles" : [
                            0.5,
                            500,
                            8e5,
                        ],
                        "zeros" : [
                            200,
                            1.1e4,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3625":{
            "rf" : 1.8e5,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2.5,
            "alpha" : 0.96,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 98e-9,
                "rOut" : 1.2e3, //16.40
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 80.251,
                        "poles" : [
                            0.50, 
                            580, 
                            1.5e4 
                        ],
                        "zeros" : [
                            180, 
                            3.3e3                      
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3630":{
            "rf" : 2.4e5,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3,
            "alpha" : 0.925,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 98e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 80.127,
                        "poles" : [
                            0.5,
                            370,
                            5e4,
                        ],
                        "zeros" : [
                            125,
                            5e3,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3633":{
            "rf" : 2.76e5,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3,
            "alpha" : 0.93,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 98e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 80.109,
                        "poles" : [
                            0.5,
                            400,
                            4e4,
                        ],
                        "zeros" : [
                            125,
                            6e3,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3640":{
            "rf" : 3.7152e5,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3,
            "alpha" : 0.95,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 98e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 79.968,
                        "poles" : [
                            0.5,
                            370,
                            5e4,
                        ],
                        "zeros" : [
                            125,
                            4.1e3
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        "ADR3650":{
            "rf" : 4.8e5,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3,
            "alpha" : 0.97,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 98e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 80.366,
                        "poles" : [
                            0.5,
                            380,
                            4e4,
                        ],
                        "zeros" : [
                            125,
                            4e3,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },
        
        "ADR3610":{
            "rf" : 1.08e6,
            "rg" : 1.2e5,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 3.1,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 98e-9,
                "rOut" : 1.2e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 82.367,
                        "poles" : [
                            0.5,
                            300,
                            2.5e4,
                        ],
                        "zeros" : [
                            105,
                            2.5e3,
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : []
                    }
                }
            }
        },

        "ADR4520":{
            "cmin" : 1e-6,
            "rf" : 524,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 17.14e-9,
                "rOut" : 29.24,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 100,
                        "poles" : [
                            0.0847,
                        ],
                        "zeros" : [                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : [3.09093097e-08, 2.71668811e-08, 2.48587104e-08, 2.36365779e-08,
                            2.19530352e-08, 2.07681951e-08, 2.12942351e-08, 2.00666752e-08,
                            1.95382968e-08, 1.90678045e-08, 1.89011071e-08, 1.84896604e-08,
                            1.84079292e-08, 1.80759953e-08, 1.78500146e-08, 1.77459918e-08,
                            1.84557641e-08, 1.75840409e-08, 1.79002894e-08, 1.80676745e-08,
                            1.83245200e-08, 1.75974463e-08, 1.80415267e-08, 1.72075319e-08,
                            1.75011677e-08, 1.73922424e-08, 1.71045647e-08, 1.73958073e-08,
                            1.68224002e-08, 1.66564871e-08, 1.72115912e-08, 1.64029987e-08,
                            1.58394345e-08, 1.56420244e-08, 1.49218364e-08, 1.37164091e-08,
                            1.43604945e-08, 1.56797486e-08, 1.95125068e-08, 2.60088333e-08,
                            3.44871679e-08, 4.59836955e-08]
                    }
                }
            }
        },
        "ADR4525":{
            "cmin" : 1e-6,
            "rf" : 750,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 16.64e-9,
                "rOut" : 34, //45.45
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 100, //50.15
                        "poles" : [
                            0.102,//25.12
                        ],
                        "zeros" : [
                    
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : [2.87502327e-08, 2.64028527e-08, 2.61939969e-08, 2.35709927e-08,
                            2.28718066e-08, 2.22366583e-08, 2.16459365e-08, 2.10808737e-08,
                            2.08088790e-08, 1.97283616e-08, 1.86916877e-08, 1.92706871e-08,
                            1.89064003e-08, 1.83196222e-08, 1.83798001e-08, 1.87310174e-08,
                            1.85569496e-08, 1.85639841e-08, 1.79580302e-08, 1.83279739e-08,
                            1.86254347e-08, 1.80365348e-08, 1.84208657e-08, 1.80802400e-08,
                            1.86278162e-08, 1.81018363e-08, 1.83664044e-08, 1.62445941e-08,
                            1.65835475e-08, 1.60387405e-08, 1.62249965e-08, 1.56466861e-08,
                            1.51548208e-08, 1.44184320e-08, 1.28817308e-08, 1.22435987e-08,
                            1.25959305e-08, 1.38445731e-08, 1.78441704e-08, 2.46407601e-08,
                            3.25620130e-08, 4.23018283e-08]
                    }
                }
            }
        },
        "ADR4530":{
            "cmin" : 1e-6,
            "rf" : 1000,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 21.42e-9,
                "rOut" : 19.26,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 100,
                        "poles" : [
                            0.116
                        ],
                        "zeros" : [                      
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : [3.50333845e-08, 3.37400465e-08, 3.21118305e-08, 3.11809873e-08,
                            3.00094919e-08, 2.88882210e-08, 2.74767587e-08, 2.65071554e-08,
                            2.52864973e-08, 2.48734130e-08, 2.43537408e-08, 2.35909630e-08,
                            2.26306840e-08, 2.23410809e-08, 2.19767975e-08, 2.19258429e-08,
                            2.18618044e-08, 2.19105767e-08, 2.19720057e-08, 2.19489276e-08,
                            2.19199103e-08, 2.17515040e-08, 2.15396551e-08, 2.15475598e-08,
                            2.15580455e-08, 2.15286623e-08, 2.14927992e-08, 2.14757844e-08,
                            2.14574724e-08, 2.13713092e-08, 2.12718569e-08, 2.05848959e-08,
                            1.97442396e-08, 1.89500516e-08, 1.80387402e-08, 1.68812309e-08,
                            1.56511034e-08, 1.57328849e-08, 1.62204191e-08, 1.90110345e-08,
                            2.21844353e-08]
                    }
                }
            }
        },
        "ADR4533":{
            "cmin" : 1e-6,
            "rf" : 1150,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 22.57e-9,
                "rOut" : 19.03,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 100,
                        "poles" : [
                            0.1372 //38.02
                        ],
                        "zeros" : [                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : [4.62491031e-08, 4.33811804e-08, 3.97706798e-08, 3.70072341e-08,
                            3.35288462e-08, 3.21399426e-08, 3.03921563e-08, 2.93682625e-08,
                            2.80792580e-08, 2.72224113e-08, 2.61439607e-08, 2.54734921e-08,
                            2.46294313e-08, 2.42852360e-08, 2.38521811e-08, 2.34824640e-08,
                            2.30171438e-08, 2.28032185e-08, 2.25340641e-08, 2.25517007e-08,
                            2.25744672e-08, 2.23771467e-08, 2.21297390e-08, 2.20485153e-08,
                            2.19489479e-08, 2.17839523e-08, 2.15823874e-08, 2.16554517e-08,
                            2.17641051e-08, 2.16452188e-08, 2.15306082e-08, 2.10110698e-08,
                            2.04077779e-08, 1.97953873e-08, 1.90609954e-08, 1.87583107e-08,
                            1.82998534e-08, 1.79845432e-08, 1.69896450e-08, 1.74424095e-08,
                            1.70216422e-08]
                    }
                }
            }
        },
        "ADR4540":{
            "cmin" : 1e-6,
            "rf" : 1548,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 23.49e-9,
                "rOut" : 22.43,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 100, //47.53
                        "poles" : [
                            0.1309 // 63.1
                        ],
                        "zeros" : [                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : [4.69821508e-08, 4.33287609e-08, 3.87294156e-08, 3.64886051e-08,
                            3.36687555e-08, 3.23231169e-08, 3.06296284e-08, 2.97138346e-08,
                            2.85609209e-08, 2.80855055e-08, 2.74873210e-08, 2.66096934e-08,
                            2.55048396e-08, 2.49166993e-08, 2.41765745e-08, 2.39768213e-08,
                            2.37256299e-08, 2.36272025e-08, 2.35035662e-08, 2.35027110e-08,
                            2.35024049e-08, 2.32616342e-08, 2.29601214e-08, 2.29220061e-08,
                            2.28784438e-08, 2.27461357e-08, 2.25896673e-08, 2.28651364e-08,
                            2.32410404e-08, 2.29450486e-08, 2.26210132e-08, 2.18355753e-08,
                            2.08918750e-08, 2.04457492e-08, 1.98988155e-08, 1.96402235e-08,
                            1.90404196e-08, 1.93944954e-08, 1.90909850e-08, 1.99601321e-08,
                            1.97413137e-08]
                    }
                }
            }
        },
        "ADR4550":{
            "cmin" : 1e-6,
            "rf" : 2000,
            "rg" : 500,
            "rs" : 1e-20,
            "cs" : 0,
            "flickerNoiseCorner" : 2,
            "alpha" : 1,
            "bandgapOutputNoise" : 1e-9,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 20.59e-9,
                "rOut" : 28, //61.09
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 100,
                        "poles" : [
                            0.362 //63.1
                        ],
                        "zeros" : [
                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 1,
                        "yValues" : [4.12972098e-08, 3.74085616e-08,
                            3.56281380e-08, 3.09804490e-08, 3.17539825e-08, 3.01220357e-08,
                            2.69713396e-08, 2.66840236e-08, 2.55799047e-08, 2.32006967e-08,
                            2.38225151e-08, 2.24735383e-08, 2.11323573e-08, 2.17551594e-08,
                            2.12991080e-08, 2.14054672e-08, 2.11235165e-08, 2.10359507e-08,
                            2.04205953e-08, 2.08726837e-08, 2.09630035e-08, 2.02026435e-08,
                            2.06055151e-08, 1.99021318e-08, 2.04498475e-08, 1.99553736e-08,
                            2.04836957e-08, 2.06011291e-08, 2.02889961e-08, 1.99367045e-08,
                            1.89466241e-08, 1.83047318e-08, 1.65636770e-08, 1.48744438e-08,
                            1.30448181e-08, 1.11967793e-08, 9.11452997e-09, 7.49418747e-09,
                            7.00502216e-09, 8.15257211e-09, 1.11204785e-08, 1.48539590e-08
                        ]
                    }
                }
            }
        }, 

        "LTZ1000":{},

        // This is not a stand alone part - it's the 2.048V reference inside the ADAQ2387X family of uModules.  
        // The "voltageNoiseDensity" data below has been bench measured on the uModule and therefore takes into account the 0.1uF output cap which is inside the uModule.
        "ADAQ2387X_INT_REF":{
            "rf" : 1e-3,
            "rg" : 1e9,
            "rs" : 1e-20,
            "flickerNoiseCorner" : 100,
            "bandgapOutputNoise" : 1e-12,
            "opAmp" : {
                "iNoise" : 0,
                "vNoise" : 1e-12,
                "rOut" : 15e3,
                "tpcData" : {
                    "openLoopGain" : {
                        "dataFormat": "pole zero",
                        "xUnits" : "Hz",
                        "yUnits" : "Db, Degrees",
                        "dcGain" : 60,
                        "poles" : [
                            // Dominant pole calculated in model,
                        ],
                        "zeros" : [                     
                        ]
                    },
                    "voltageNoiseDensity" : {
                        "dataFormat" : "10 points per decade",
                        "xUnits" : "Hz",
                        "yUnits" : "V/rt(Hz)",
                        "xAxisStart" : 0.1,
                        "yValues" : [
                            6.200E-06,
                            5.050E-06,
                            4.330E-06,
                            3.555E-06,
                            3.525E-06,
                            3.235E-06,
                            2.820E-06,
                            2.095E-06,
                            2.155E-06,
                            2.060E-06,
                            1.965E-06,
                            1.470E-06,
                            1.345E-06,
                            1.290E-06,
                            1.135E-06,
                            9.000E-07,
                            8.100E-07,
                            7.450E-07,
                            6.500E-07,
                            5.800E-07,
                            5.150E-07,
                            4.500E-07,
                            3.770E-07,
                            3.160E-07,
                            2.895E-07,
                            2.645E-07,
                            2.195E-07,
                            1.850E-07,
                            1.565E-07,
                            1.300E-07,
                            1.115E-07,
                            8.850E-08,
                            7.150E-08,
                            5.400E-08,
                            4.130E-08,
                            3.210E-08,
                            2.450E-08,
                            1.865E-08,
                            1.420E-08,
                            9.900E-09,
                            7.650E-09,
                            5.750E-09,
                            4.315E-09,
                            3.235E-09,
                            2.425E-09,
                            1.820E-09,
                            1.365E-09,
                            1.025E-09,
                            7.650E-10,
                            5.750E-10,
                            4.315E-10,
                            3.235E-10,
                            2.425E-10,
                            1.820E-10,
                            1.365E-10,
                            1.025E-10,
                            7.650E-11,
                            5.750E-11,
                            4.315E-11,
                            3.235E-11,
                            2.425E-11,
                            1.820E-11,
                            1.365E-11,
                            1.025E-11,
                            7.650E-12,
                            5.750E-12,
                            4.315E-12,
                            3.235E-12
                        ]
                    }
                }
            }
        },
                            
    }
}